import Button from '@rio-cloud/rio-uikit/Button';
import type { ReactNode } from 'react';

import { PolicyAndPricingLinks } from '@/components/steps/PolicyAndPricingLinks';
import { t } from '@/lib/utils';

export type StepBodyProps = {
    stepId: string;
    handleNext: () => void;
    handleBack?: () => void;
    children: ReactNode;
    isOrderNewCard?: boolean;
};

const StepBody = ({ stepId, handleNext, handleBack, children, isOrderNewCard = false }: StepBodyProps) => {
    const renderButtons = () => (
        <div className={`btn-toolbar display-flex ${handleBack ? 'justify-content-between' : 'justify-content-end'}`}>
            {handleBack && (
                <Button className='width-100' onClick={handleBack}>
                    <span className='rioglyph rioglyph-chevron-left text-bold text-size-14 padding-right-5' />
                    <span>{t('onboarding.button.back')}</span>
                </Button>
            )}
            <Button className='width-100' onClick={handleNext} bsStyle='primary'>
                <span className='padding-right-5'>{t('onboarding.button.next')}</span>
                <span className='rioglyph rioglyph-chevron-right text-bold text-size-14' />
            </Button>
        </div>
    );

    const renderContent = () => (
        <>
            {children}
            <div className='text-size-12 padding-bottom-15 text-italic'>{t('general.fieldsAreRequired')}</div>
            {renderButtons()}
        </>
    );

    if (isOrderNewCard) {
        return renderContent();
    }

    return (
        <div className='display-flex flex-column'>
            <div className='display-flex flex-column align-items-center'>
                <div className='text-bold text-size-h3 padding-bottom-10'>{t(`onboarding.${stepId}.title`)}</div>
                <div className='text-size-14'>{t(`onboarding.${stepId}.description`)}</div>
            </div>
            {renderContent()}
            <PolicyAndPricingLinks />
        </div>
    );
};

export default StepBody;
